import InlineSvg from './InlineSvg'

export default InlineSvg
